import React, { useContext, useState } from "react";
import { FunctionContext } from "../../context/FunctionProvider";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

function HeaderButtons({ setOpenPostWalkInDialog }) {
  const { t , changeLanguage } = useContext(FunctionContext);
  const [lang, setLang] = useState('');
  const handleChangeLang = (e) =>{
    setLang(e.target.value);
    changeLanguage(e.target.value);
  }
  
  return (
    <>
      {/* <button className="modern-button searchbutton ouline-b flex center">
        <p className="m-0 p text-xs">{t("login")}</p>
      </button> */}
      <button
        className="modern-button searchbutton flex center"
        onClick={() => setOpenPostWalkInDialog(true)}
      >
        <p className="m-0 p text-xs">{t("postyourwalkin")}</p>
      </button>
      {/* dropdown to change language */}
      
      {/* <FormControl  sx={{ m: 1, minWidth: 80 }}>
        <InputLabel id="demo-simple-select-label">{t("language")}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={lang}
          label={t("language")}
          autoWidth
          onChange={handleChangeLang}
        >
          <MenuItem value='English'>{t("english")}</MenuItem>
          <MenuItem value='Tamil'>{t("tamil")}</MenuItem>
        </Select>
      </FormControl> */}
    </>
  );
}

export default HeaderButtons;
